import { create } from "zustand"

type SidebarSearchState = {
  query: string
  setQuery: (query: string) => void
}

export const useSidebarSearchStore = create<SidebarSearchState>()((set) => ({
  query: "",
  setQuery: (query) => set({ query })
}))
